import ApiBase from 'Services/Api/ApiBase';

class ServiceUserMedications extends ApiBase {
    route = '/service-users/medications';

    /**
     * Copy a medication line with all of its MARS entries (admin only).
     *
     * @method duplicate
     * @param {string} id
     * @return {Promise<*>}
     */
    duplicate = (id) => this.post(`${id}/duplicate`, {}, 'updated');
};

export default new ServiceUserMedications();
